import { useQuery } from 'react-query';
import axios from 'axios';
import { apiBaseUrl } from 'config';
import { useAuth } from '../Contexts/AuthProvider';
import { resolveFileUrl } from '../helpers';

const getDataExport = async ({ companyId, tabType }) => {
    const { data } = await axios(`${apiBaseUrl}/dataexport/${tabType}`, {
        headers: { 'CompanyId': companyId },
    });
    if (data?.url) {
        return { ...data, url: resolveFileUrl(data.url) };
    }
    return data;
};

export default function useDataExport(tabType = 'jobs') {
    const { userLoaded, currentCompany } = useAuth();
    return useQuery(['data-export', tabType], () => getDataExport({tabType, companyId: currentCompany?.id }),
        {
            initialData: {},
            keepPreviousData: true,
            refetchOnWindowFocus: false,
            enabled: !!userLoaded,
        });
}



